import React from "react"
import { useProjectStore } from "stores/projectStore"

/**
 * Renders the status of a project.
 *
 * This component displays the current status of a project along with
 * additional information such as awaiting data and reporting.
 *
 * @component
 * @returns  The rendered ProjectStatus component.
 */
const ProjectStatus: React.FC = () => {
  const project = useProjectStore((state) => state.project)

  return (
    <span
      className="inline-flex items-center rounded-full bg-[#e0f6fd] px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-[#0e7490]"
      title="Project status"
    >
      {project.Status}
    </span>
  )
}

export default ProjectStatus
